export const QA_NAME_RECIPIENTS_SELECT = 'recipients-select'
